import Section from './Section';
// Import enumerations.
import {
	NewBusinessApplicationSectionName,
} from '@app/enumerations';

export default class NewBusinessApplicationSection extends Section<NewBusinessApplicationSectionName> {

	public key: string | null = null;
	public unsubmitNewBusinessApplicationOnChange: boolean | null = null;
	public subSections: NewBusinessApplicationSection[] = [];

	public constructor() {
		super();
	}
};